/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Initialize_Stripe_ConnectInputs */

const en_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize Stripe Connect`)
};

const es_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializar Stripe Connect`)
};

const fr_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialiser Stripe Connect`)
};

const de_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect initialisieren`)
};

const ja_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connectを初期化`)
};

const zh_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初始化 Stripe Connect`)
};

const ar_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تهيئة Stripe Connect`)
};

const id_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi Stripe Connect`)
};

const it_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizializza Stripe Connect`)
};

const ru_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инициализировать Stripe Connect`)
};

const pt_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializar Stripe Connect`)
};

const ko_initialize_stripe_connect = /** @type {(inputs: Initialize_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect 연동 시작`)
};

/**
* | output |
* | --- |
* | "Initialize Stripe Connect" |
*
* @param {Initialize_Stripe_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const initialize_stripe_connect = /** @type {((inputs?: Initialize_Stripe_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Initialize_Stripe_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_initialize_stripe_connect(inputs)
	if (locale === "es") return es_initialize_stripe_connect(inputs)
	if (locale === "fr") return fr_initialize_stripe_connect(inputs)
	if (locale === "de") return de_initialize_stripe_connect(inputs)
	if (locale === "ja") return ja_initialize_stripe_connect(inputs)
	if (locale === "zh") return zh_initialize_stripe_connect(inputs)
	if (locale === "ar") return ar_initialize_stripe_connect(inputs)
	if (locale === "id") return id_initialize_stripe_connect(inputs)
	if (locale === "it") return it_initialize_stripe_connect(inputs)
	if (locale === "ru") return ru_initialize_stripe_connect(inputs)
	if (locale === "pt") return pt_initialize_stripe_connect(inputs)
	return ko_initialize_stripe_connect(inputs)
});